import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './ns-event-banner.html';
import '@nuskin/ns-style-elements';
import {SitesSessionStorageService, util} from "@nuskin/ns-util";


/**
 * <p>The ns-event-banner shows up in the header and defined in page attributes. If defined it will override the default marketing banner for that page.</p>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-event-banner text="Black Friday"></ns-event-banner>
 *   </template>
 * </demo-snippet>
 *
 * <marked-element>
 *  <div slot="markdown-html">
 *  <script type="text/markdown">
 *
 *  </script>
 * </marked-element>
 */
export class NsEventBanner extends PolymerElement {
    constructor() {
        super();
    }

    static get is() {
        return "ns-event-banner";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get properties() {
        return {
            text: {
                type: String,
                value: "Event Banner Text"
            },
            /**
             *
             */
            linkText: {
                type: String,
                value: ''
            },
            /**
             *
             */
            linkHref: {
                type: String,
                value: ''
            },
            /**
             */
            bannerColor: {
                type: String,
                value: "#000000"
            },
            /**
             */
            textColor: {
                type: String,
                value: "#FFFFFF"
            }
        }
    }

    ready() {
        super.ready();
        this.updateStyles({'--event-banner-color': this.bannerColor, '--event-banner-text-color': this.textColor})
    }
}

customElements.define(NsEventBanner.is, NsEventBanner);